
import { getTokenDefinition, } from "@bracket/chainography";
import { latestPriceEth, bracketRate, } from "@bracket/platform/cachables";
import { effectZero, } from "@bracket/platform/utils";
import { parseUnits, } from "viem";
import type { TokenIdentifier, WEIString,} from "@bracket/types";


export const usdToAsset = async ( usd: number, token: TokenIdentifier, rate?: number, price?: number,): Promise<WEIString> => {

  const { symbol, decimals, } = getTokenDefinition(token);

	try {
		switch(symbol) {

			case "BRKTETH": {
				price = price ?? await latestPriceEth();
				rate = rate ?? await bracketRate();
				try {
					return parseUnits(effectZero(usd/(price * rate)).toString(), decimals).toString();
				}
				catch(err) {
					console.error("usdToAsset error", err);
					return "0";
				}
			}

			case "USDC": {
				return parseUnits(effectZero(usd).toString(), decimals).toString();
			}

			case "WETH": {
				price = price ?? await latestPriceEth();
				return parseUnits(effectZero(usd/price).toString(), decimals).toString();
			}

			default: {
				throw new Error(`usdToAsset not implemented for ${symbol}`);
			}
		}

	}
	catch(err) {
		console.error("usdToAsset error", err);
		return "0";
	}

}
